
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import genericActions from "../../redux/generic/actions";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import ActivationActions from "../../redux/activation/actions";
import ToastAlert from "../../components/utils/ToastAlert";
import authActions from "../../redux/auth/actions";

const { createBulkActivation, resetMessage, getAvailableICCID } = ActivationActions;
const { getPlan, getBillingCode } = genericActions;
const { getUserDataByToken } = authActions;

const SimActivation = () => {
  const dispatch = useDispatch();
  const { planList, getPlanLoading, billingCodeList } = useSelector((state) => state.generic);
  const { bulkActivationLoading, bulkActivationMessage, bulkActivationError,
    availableICCID,
    getAvailableICCIDLoading,
    getAvailableICCIDMessage,
    getAvailableICCIDError } = useSelector((state) => state.activation);
  const [selectedPlan, setSelectedPlan] = useState({})
  const [activeTab, setActiveTab] = useState(2);
  const [isPortinActivation, setIsPortinActivation] = useState(false);
  const [getAgainIccidFlag, setGetAgainIccidFlag] = useState(false);


  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      serialnumber: "",
      planId: "",
      billingCode: "",
      streetAddress1: "",
      streetAddress2: "",
      city: "",
      state: "",
      zipCode: "",
      areaCode: "",
    },
  });

  const watchPlanId = watch('planId');

  useEffect(() => {
    if (watchPlanId) {
      const planData = planList.find(
        (item) => item?.PlanID == watchPlanId
      );
      setActiveTab(2)
      setSelectedPlan(planData);
    }
  }, [watchPlanId, planList]);

  useEffect(() => {
    if (availableICCID?.serialNumber) {
      setValue("serialnumber", availableICCID?.serialNumber || "", {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }

  }, [availableICCID]);

  useEffect(() => {
    dispatch(getPlan({ ActionType: 1, Month: 1 }))
    dispatch(getBillingCode({ ActionType: 1 }))
    dispatch(getAvailableICCID())

    return () => {
      dispatch(resetMessage());
    };
  }, [])

  useEffect(() => {
    if (billingCodeList && billingCodeList?.length > 0) {
      setValue('billingCode', billingCodeList[0]?.BillingCode)
    }
  }, [billingCodeList])


  useEffect(() => {
    if (bulkActivationMessage) {
      ToastAlert({ type: "success", text: bulkActivationMessage });
      handleReset();
      dispatch(getUserDataByToken());
    }

    if (bulkActivationError) {
      ToastAlert({ type: "error", text: bulkActivationError });
    }

    if (getAvailableICCIDError) {
      ToastAlert({ type: "error", text: getAvailableICCIDError });
    }
    if (getAgainIccidFlag && getAvailableICCIDMessage) {
      ToastAlert({ type: "success", text: getAvailableICCIDMessage });
      setGetAgainIccidFlag(false)
    }
  }, [bulkActivationMessage, bulkActivationError, getAvailableICCIDMessage, getAvailableICCIDError]);



  const onSubmit = async (data) => {
    const payload = {
      "planId": Number(data?.planId) || 0,
      "billingCode": data?.billingCode,
      "requestType": 1,
      "sims": [
        {
          "iccid": data?.serialnumber,
          "areaCode": data?.areaCode,
          "zipcode": data?.zipCode,
          "street1": data?.streetAddress1,
          "street2": data?.streetAddress2 || '',
          "city": data?.city,
          "state": data?.state,
        }
      ]
    }
    dispatch(createBulkActivation(payload))
  };


  const handleReset = () => {
    reset({
      serialnumber: "",
      planId: "",
      streetAddress1: "",
      streetAddress2: "",
      city: "",
      state: "",
      zipCode: "",
      areaCode: ""
    })
    setActiveTab(2)
    setSelectedPlan({})
  }

  const handleGetIccid = () => {
    setGetAgainIccidFlag(true)
    setValue("serialnumber", '')
    dispatch(getAvailableICCID())
  }


  return (
    <CardLayout
      title={isPortinActivation ? "Portin Activation" : "SIM Activation"}
      icon="ri-sim-card-line"
    // rightContent={<div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-end gap-2"
    // >
    //   <div
    //     className="d-flex align-items-center gap-1 rounded-pill p-1"
    //     style={{ background: "#f4f2ec", border: "1px solid #e5e2da", }}
    //   >
    //     <button
    //       type="button"
    //       className="border-0 rounded-pill px-3 py-1"
    //       onClick={() => { setIsPortinActivation(false); handleReset(); }}
    //       style={{
    //         fontSize: 13,
    //         fontWeight: 600,
    //         background: !isPortinActivation ? "#8e0f9d" : "transparent",
    //         color: !isPortinActivation ? "#fff" : "#6b6b66",
    //       }}
    //     >
    //       SIM Activation
    //     </button>

    //     <button
    //       type="button"
    //       className="border-0 rounded-pill px-3 py-1"
    //       onClick={() => { setIsPortinActivation(true); handleReset(); }}
    //       style={{
    //         fontSize: 13,
    //         fontWeight: 600,
    //         background: isPortinActivation ? "#8e0f9d" : "transparent",
    //         color: isPortinActivation ? "#fff" : "#6b6b66",
    //       }}
    //     >
    //       Portin Activation
    //     </button>
    //   </div>
    // </div>}
    >
      <div className="row">
        {/* Left Side */}
        <div className="col-lg-3 left-panel">
          <div className="quick-links">
            <div className="d-flex justify-content-between">
              <button type="button" onClick={() => setActiveTab(2)}>
                <h5 className="quick-title">Plan Summary</h5>
                {activeTab == 2 ? <div className="title-line"></div> : <div className="mb-4"></div>}
              </button>
            </div>

            <div className="d-flex flex-column gap-3">

              {/* <div className="d-flex align-items-center justify-content-between 
                  border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-tag text-primary"></i>
                  <span className="text-dark fw-semibold">Plan Price</span>
                </div>

                <span className="text-primary fw-bold">${twoDigitDecimal(selectedPlan?.PlanAmount)}</span>
              </div> */}

              <div className="d-flex align-items-center justify-content-between 
                  border rounded-3 px-3 py-3 bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa-solid fa-hand-holding-dollar text-primary"></i>
                  <span className="text-dark fw-semibold">Dealer Cost</span>
                </div>

                <span className="text-primary fw-bold">${twoDigitDecimal(selectedPlan?.DealerCost)}</span>
              </div>

              {selectedPlan?.PlanCode && <div className="d-flex justify-content-between ">
                <div className="d-flex align-items-center gap-2">
                  <small className="mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>SKU</small>
                </div>
                <span className="text-primary fw-semibold" style={{ fontSize: "13px", }}>{selectedPlan?.PlanCode}</span>
              </div>}

              {selectedPlan?.PlanDesc && <div className="">
                <div className="d-flex align-items-center gap-2">
                  <small className="mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>Plan Description</small>
                </div>
                <span className="text-primary fw-semibold" style={{ fontSize: "13px", }}>{selectedPlan?.PlanDesc}</span>
              </div>}

            </div>

          </div>
        </div>

        {/* Right Side */}
        <div className="col-lg-9">
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate

          >
            <div className="row">
              {/* Serial Number */}
              <div className="col-lg-4 mb-2">
                <label className="form-label fw-semibold">
                  Serial Number <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className={`form-control ${errors.serialnumber ? "is-invalid" : ""
                      }`}
                    placeholder="Serial Number"
                    {...register("serialnumber", {
                      required: "Serial number is required",
                      pattern: {
                        value: /^[0-9]{19}$/,
                        message: "Serial number must be exactly 19 digits",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                    }}
                    disabled={getAvailableICCIDLoading}
                  />
                  <span
                    className="input-group-text bg-white rounded-end"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleGetIccid()}
                    title="Get Available Serial Number"
                  >
                    <i className="ri-refresh-line"></i>
                  </span>
                  <div className="invalid-feedback"> {errors.serialnumber?.message} </div>
                </div>

              </div>

              {/* Plan */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Plan <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-select ${errors.planId ? "is-invalid" : ""
                    }`}
                  disabled={getPlanLoading}
                  {...register("planId", {
                    required: "Plan is required",
                  })}
                >
                  <>
                    <option value="">Select Plan</option>
                    {planList?.map((item) => (
                      <option key={item?.PlanID} value={item?.PlanID}>
                        {item?.PlanName}
                      </option>
                    ))}
                  </>
                </select>

                <div className="invalid-feedback"> {errors.planId?.message} </div>
              </div>

              {/* Billing Code */}
              {/* <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Billing Code <span className="text-danger">*</span>
                </label>

                <select
                  className={`form-select ${errors.billingCode ? "is-invalid" : ""
                    }`}
                  {...register("billingCode", {
                    required: "Billing code is required",
                  })}
                >
                  <option value="">Select Billing Code</option>
                  {billingCodeList && billingCodeList.length > 0 && billingCodeList.map((item) => (
                    <option key={item?.BillingCode} value={item?.BillingCode}>
                      {item?.BillingCode}
                    </option>
                  ))}
                </select>
                <div className="invalid-feedback"> {errors.billingCode?.message} </div>
              </div> */}

              {isPortinActivation && <>
                {/*  MSISDN To Port */}
                <div
                  className="col-lg-4 mb-2"
                >
                  <label className="form-label fw-semibold">
                    MSISDN To Port <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    maxLength={10}
                    className={`form-control ${errors.msisdntoPort ? "is-invalid" : ""
                      }`}
                    placeholder="MSISDN To Port"
                    {...register("msisdntoPort", {
                      required: "MSISDN is required",
                      validate: (value) => {
                        const val = value.trim();

                        if (val && !/^\d+$/.test(val)) {
                          return "Only numbers are allowed";
                        }

                        if (val.length > 10) {
                          return "MSISDN cannot be more than 10 digits";
                        }
                        return true;
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    }}
                  />
                  <div className="invalid-feedback"> {errors.msisdntoPort?.message} </div>
                </div>

                {/* Subscriber  Name */}
                <div
                  className="col-lg-4 mb-2"
                >
                  <label className="form-label fw-semibold">
                    Subscriber Name <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${errors.subscriberName ? "is-invalid" : ""}`}
                    placeholder="Subscriber Name"
                    {...register("subscriberName", {
                      required: "Subscriber name is required",
                    })}
                  />

                  <div className="invalid-feedback"> {errors.subscriberName?.message} </div>
                </div>

                {/*  Account Number */}
                <div
                  className="col-lg-4 mb-2"
                >
                  <label className="form-label fw-semibold">
                    Account Number <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${errors.accountNumber ? "is-invalid" : ""
                      }`}
                    placeholder="Account Number"
                    {...register("accountNumber", {
                      required: "Account number is required",
                    })}
                  />

                  <div className="invalid-feedback"> {errors.accountNumber?.message} </div>
                </div>

                {/*  Account Password */}
                <div
                  className="col-lg-4 mb-2"
                >
                  <label className="form-label fw-semibold">
                    Account Password <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${errors.accountPassword ? "is-invalid" : ""
                      }`}
                    placeholder="Account Password"
                    {...register("accountPassword", {
                      required: "Account password is required",
                      // pattern: {
                      //   value: /^\d{5}(-\d{4})?$/,
                      //   message: "Invalid ZIP Code",
                      // },
                    })}
                  />

                  <div className="invalid-feedback"> {errors.accountPassword?.message} </div>
                </div>

              </>}

              {/* Area Code */}
              <div
                className="col-lg-4 mb-2"
              >
                <label className="form-label fw-semibold">
                  Zip Code For Area Code <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.areaCode ? "is-invalid" : ""
                    }`}
                  placeholder="Zip Code For Area Code"
                  {...register("areaCode", {
                    required: "Zip Code For Area Code is required",
                  })}
                />

                <div className="invalid-feedback"> {errors.areaCode?.message} </div>
              </div>


              <>
                <div className="col-lg-12 mt-2">
                  <div className="title-card">
                    <h5 className="title title-card-heading"> E911 Address </h5>

                    <div className="row">
                      {/* Address 1 */}
                      <div className="col-lg-4 mb-3">
                        <label className="form-label fw-semibold">
                          Street Address 1 <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className={`form-control ${errors.streetAddress1 ? "is-invalid" : ""
                            }`}
                          placeholder="Street Address 1"
                          {...register("streetAddress1", {
                            required: "Street address 1 is required",
                          })}
                        />

                        <div className="invalid-feedback">
                          {errors.streetAddress1?.message}
                        </div>
                      </div>

                      {/* Address 2 */}
                      <div className="col-lg-4 mb-3">
                        <label className="form-label fw-semibold">
                          Street Address 2
                        </label>

                        <input
                          type="text"
                          className={`form-control ${errors.streetAddress2 ? "is-invalid" : ""
                            }`}
                          placeholder="Street Address 2"
                          {...register("streetAddress2")}
                        />

                        <div className="invalid-feedback">
                          {errors.streetAddress2?.message}
                        </div>
                      </div>

                      {/* City */}
                      <div className="col-lg-4 mb-3">
                        <label className="form-label fw-semibold">
                          City <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className={`form-control ${errors.city ? "is-invalid" : ""
                            }`}
                          placeholder="City"
                          {...register("city", {
                            required: "City is required",
                          })}
                        />

                        <div className="invalid-feedback">
                          {errors.city?.message}
                        </div>
                      </div>

                      {/* State */}
                      <div className="col-lg-4 mb-3">
                        <label className="form-label fw-semibold">
                          State <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className={`form-control ${errors.state ? "is-invalid" : ""
                            }`}
                          placeholder="State"
                          {...register("state", {
                            required: "State is required",
                          })}
                        />

                        <div className="invalid-feedback">
                          {errors.state?.message}
                        </div>
                      </div>

                      {/* ZIP Code */}
                      <div className="col-lg-4 mb-3">
                        <label className="form-label fw-semibold">
                          ZIP Code <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className={`form-control ${errors.zipCode ? "is-invalid" : ""
                            }`}
                          placeholder="ZIP Code"
                          {...register("zipCode", {
                            required: "ZIP code is required",
                          })}
                        />

                        <div className="invalid-feedback">
                          {errors.zipCode?.message}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>

              {/* Submit */}
              <div
                className="col-lg-12 d-flex justify-content-end mt-3 gap-2 align-items-center"
                style={{ height: '70px' }}
              >
                <Button
                  buttonType="button"
                  title="Reset"
                  disable={bulkActivationLoading}
                  variant="secondary"
                  icon={<i className="ri-refresh-line me-2"></i>}
                  onClick={handleReset}
                />

                <Button
                  buttonType="submit"
                  title="Activate"
                  loading={bulkActivationLoading}
                  icon={<i className="ri-send-plane-fill me-2"></i>}
                />
              </div>

            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};

export default SimActivation;
